import { Outlet } from 'react-router-dom';
import { Receipt, AddressBook, Gear, ChartPieSlice, CurrencyJpy, Storefront } from '@phosphor-icons/react';
import { useAuth, isAdmin } from '@/auth/AuthContext';
import { ModuleSidebar } from '@/components/enterprise/ModuleSidebar';

// UX consolidation (2026-06): one sidebar owner. No brand card, no tagline,
// no module-specific accent — module identity lives in the global header chip.
export default function MarketingLayout() {
  const { user } = useAuth();
  const sections = [
    { items: [
      { to: '/marketing', end: true, label: 'ダッシュボード', icon: ChartPieSlice, testid: 'mkt-nav-dashboard' },
      { to: '/marketing/orders', label: '受注一覧', icon: Receipt, testid: 'mkt-nav-orders' },
      { to: '/marketing/customers', label: '客先マスタ', icon: AddressBook, testid: 'mkt-nav-customers' },
      { to: '/marketing/billing', label: '締め請求', icon: CurrencyJpy, testid: 'mkt-nav-billing' },
      ...(isAdmin(user)
        ? [{ to: '/marketing/settings', label: '受注設定', icon: Gear, testid: 'mkt-nav-settings' }]
        : []),
    ] },
  ];
  return (
    <div className="flex flex-col md:flex-row gap-5 md:gap-6" data-testid="marketing-layout">
      <ModuleSidebar icon={Storefront} title="営業" sections={sections} testid="mkt-sidebar" />
      <div className="flex-1 min-w-0">
        <Outlet />
      </div>
    </div>
  );
}
